// src/logger.ts
var now = () => {
  const [date, time] = (/* @__PURE__ */ new Date()).toISOString().split(/[T.]/);
  return `${date} ${time}`;
};
var logger = {
  debug: (...args) => {
    console.debug(now(), "[DEBUG]", ...args);
  },
  info: (...args) => {
    console.info(now(), "[INFO]", ...args);
  },
  warn: (...args) => {
    console.warn(now(), "[WARN]", ...args);
  },
  error: (...args) => {
    console.error(now(), "[ERROR]", ...args);
  }
};
var logger_default = logger;

export {
  logger_default
};
